// @ts-nocheck
import dataReducer, { DataActions } from "@store/Framework/Store/Store/Data/DataReducer";
import pagesReducer, { PagesActions } from "@store/Framework/Store/Store/Pages/PagesReducer";
import componentsReducer, { ComponentsActions } from "@store/Framework/Store/Store/Components/ComponentsReducer";
import { combineReducers } from "redux";

const storeReducer = combineReducers({
    components: componentsReducer,
    data: dataReducer,
    pages: pagesReducer,
});

export type StoreActions = ComponentsActions | PagesActions | DataActions;

export default storeReducer;
